import React from "react";

const TableFilter = ({ children }) => {
  return (
    <>
      <div className="pb-3 my-3 d-flex justify-content-between align-items-center border-bottom">{children}</div>
    </>
  );
};

export default TableFilter;
